





















































































import { Component, Mixins } from "vue-property-decorator";
import dateranges from "@/data/dateranges";
import AdminBrandId from "@/mixins/adminBrandId";
import StatsStorageMixin from "@/mixins/statsStorageMixin";

@Component({
  components: {
    "chart-provider": () =>
      import("@/components/app/global/stats/charts/chart/chartProvider.vue"),
    "stat-header": () => import("@/components/app/global/stats/statHeader.vue"),
    "recent-invoices-list": () =>
      import("@/components/app/global/invoices/recentInvoicesList.vue"),
    "timeline-component": () =>
      import("@/components/app/global/timelineComponent/index.vue"),
    "invoices-total-active": () =>
      import("@/components/app/global/stats/invoicesTotal.vue"),
    "invoices-average-value": () =>
      import("@/components/app/global/stats/invoiceAverageValue.vue"),
    "invoices-total-paid": () =>
      import("@/components/app/global/stats/invoicesTotalPaid.vue"),
    "invoices-total-unpaid": () =>
      import("@/components/app/global/stats/invoicesTotalUnpaid.vue"),
    "invoices-total-overdue": () =>
      import("@/components/app/global/stats/invoicesTotalOverdue.vue"),
    "chart-revenue": () =>
      import("@/components/app/global/stats/charts/revenueChart.vue")
  }
})
export default class AdminInvoicesOverview extends Mixins(
  AdminBrandId,
  StatsStorageMixin
) {
  public range = this.tryGetStatDateFromStorage(dateranges.ranges.last30days);

  public currencyCode = null;
}
